import { SecurityInventoryCategory, SecurityInventoryItem } from '@x-guard/xgac-types/xgac';
import { Identifier, useRecordContext } from 'react-admin';
import { useMemo } from 'react';
import { Checkbox, IconButton, Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { WarningAmber } from '@mui/icons-material';
import {
  InventoryCategoryIconName,
} from '../../../components/icons/inventoryCategoryIcons';
import { IconField } from '../../../components/fields/IconField';
import { ExpiryStatus } from '../../../../../utils/certificationsAndItemsExpiry';

export type InventoryItemListRecord = SecurityInventoryItem & {
  expiryStatus: ExpiryStatus;
};

const NameDisplay = (props: { name: string }) => {

  return (
    <Box sx={{
      fontWeight: 'bold',
      marginLeft: '15px',
    }}>
      {props.name}
    </Box>
  );

};
export const DataGridListItem = (props: {
  mouseHoverId: Identifier | null;
  categories: SecurityInventoryCategory[];
  onHover: (itemId: Identifier | null) => void;
  selectable: boolean;
  selectedIds: Identifier[];
  onSelectionChange: (selectedIds: Identifier[]) => void;
  onEdit: (item: SecurityInventoryItem) => void;
}) => {

  const record = useRecordContext<InventoryItemListRecord>();
  const iconName = useMemo(() => {

    return props.categories.find((c) => c._id === record?.category._id)?.icon as InventoryCategoryIconName;

  }, [props.categories, record?.category._id]);

  if (!record) return null;

  const showIdleRow = props.mouseHoverId !== record._id && props.selectedIds.length === 0;
  const showExpiryWarning = record.expiryStatus === 'expiring' || record.expiryStatus === 'expired';

  function handleSelectionChange() {

    if (!record) return;
    if (props.selectedIds.includes(record._id)) {

      props.onSelectionChange(props.selectedIds.filter((selectedId) => selectedId !== record._id));

    } else {

      props.onSelectionChange([...props.selectedIds, record._id]);

    }

  }

  return (
    <div
      id={`inventory-item-${record._id}`}
      onMouseEnter={() => props.onHover(record._id)}
      onMouseLeave={() => props.onHover(null)}
      onClick={() => {

        if (!props.selectable) return;
        handleSelectionChange();

      }}
      style={{ cursor: 'pointer' }}
    >
      <div className={props.selectedIds.includes(record._id) ? 'button-sidebar-grid-row selected-row' : 'button-sidebar-grid-row'}>
        {showIdleRow ? (
          <>
            <div className="button-sidebar-grid-name">
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 15,
                height: 15,
                flexShrink: 0,
              }}>
                <IconField iconName={iconName} source={iconName} />
              </Box>
              <NameDisplay name={record.name} />
            </div>
            <Box sx={{
              width: 32,
              flexShrink: 0,
              display: 'flex',
              justifyContent: 'center',
              alignSelf: 'center',
            }}>
              {showExpiryWarning && <WarningAmber sx={{ color: 'warning.main' }} />}
            </Box>
          </>
        ) : (
          <>
            <div className="button-sidebar-grid-name">
              <Checkbox
                checked={props.selectedIds.includes(record._id)}
                disabled={!props.selectable}
                size="small"
                className="button-sidebar-checkbox"
                onClick={(e) => {

                  e.stopPropagation();
                  if (!props.selectable) return;
                  handleSelectionChange();

                }}
              />
              <NameDisplay name={record.name} />
            </div>
            <Box sx={{
              width: 32,
              flexShrink: 0,
              display: 'flex',
              justifyContent: 'center',
              alignSelf: 'center',
            }}>
              {props.mouseHoverId === record._id && (
                <IconButton
                  size="small"
                  sx={{ padding: 0, margin: 0 }}
                  onClick={(e) => {

                    e.stopPropagation();
                    props.onEdit(record);

                  }}
                >
                  <EditIcon sx={{ padding: 0, margin: 0, fontSize: '20px' }} />
                </IconButton>
              )}
              {props.mouseHoverId !== record._id && showExpiryWarning
                && <WarningAmber sx={{ color: 'warning.main' }} />}
            </Box>
          </>
        )}
      </div>
    </div>
  );

};
